import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Spinner from 'components/Spinner'
import Message from 'components/Message'
import Placeholder from 'components/Placeholder'
import ImageGallery from 'components/ImageGallery/ImageGallery'
import ImageReviewPopup from 'components/ImageGallery/ImageReviewPopup'
import EmptyLogo from 'images/empty_folder.png'
import { deleteImage, getImages, updateImage } from 'slices/locationImageSlice'
import notify from 'components/ui/notify'

export interface Props {
	className?: string
	showPlaceholder?: boolean
	[x: string]: any
}

const ImageGalleryContainer = ({ locationid, projectid, showPlaceholder = true }: Props) => {
	const dispatch = useDispatch()

	console.log('locationid: ', locationid)
	console.log('projectid: ', projectid)

	const [openReview, setOpenReview] = useState(false)
	const [recordForEdit, setRecordForEdit] = useState<any>(null)

	const userLogin = useSelector((state: any) => state.userLogin)
	const { userInfo } = userLogin
	const userid = userInfo._id

	const {
		entities: imageEntities,
		ids: imageIds,
		isInitialized,
		isLoading: loading,
		error,
	} = useSelector((state: any) => state.locationImages)
	const locationImages = imageIds.map(id => imageEntities[id])

	useEffect(() => {
		// @ts-ignore
		if (!isInitialized) {
			dispatch(getImages({ locationid, projectid, userid }))
		}
	}, [dispatch, userid, locationid, projectid, isInitialized])

	const deleteImageHandler = async image => {
		const imageId = image._id
		const userId = image.userid._id

		if (userid === userId) {
			dispatch(deleteImage({ imageid: imageId }))
			dispatch(getImages({ locationid, projectid, userid }))
		} else {
			notify('You do not have delete privileges for this image.', {
				icon: 'warning',
			})
		}
	}

	const updateImageHandler = async (image: any) => {
		await dispatch(updateImage(image))
		dispatch(getImages({ locationid, projectid, userid }))
		setOpenReview(false)
	}

	const handleDeleteImage = image => {
		setRecordForEdit(image)
		setOpenReview(true)
	}

	const handlePreviewImage = image => {
		setRecordForEdit(image)
		setOpenReview(true)
	}

	const hasImages = locationImages.length > 0
	if (loading) return <Spinner containerHeight="50vh" />
	if (error) return <Message variant="danger">{error}</Message>

	return (
		<div>
			<div>
				{hasImages ? (
					<ImageGallery
						locationImages={locationImages}
						handleDeleteImage={handleDeleteImage}
						handlePreviewImage={handlePreviewImage}
					/>
				) : showPlaceholder ? (
					<Placeholder aspectRatio="16:9" isFlexColumn isTransparent>
						<h2 className="h2">{`Select 'Upload New Image' to add your first image.`}</h2>
						<div>
							<img className="details__avatar_noHover" src={EmptyLogo} alt="Avatar" />
						</div>
					</Placeholder>
				) : null}{' '}
			</div>
			<ImageReviewPopup
				open={openReview}
				onClose={() => {
					setOpenReview(false)
					setRecordForEdit(null)
				}}
				image={recordForEdit}
				onUpdateNote={updateImageHandler}
				onDeleteImage={deleteImageHandler}
			/>
		</div>
	)
}

export default ImageGalleryContainer
